"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LdmModule = void 0;
var LdmModule = /** @class */ (function () {
    function LdmModule(xhr) {
        this.xhr = xhr;
    }
    /**
     * Get closest connecting attributes in the LDM by calling the "attributeupperbound" endpoint
     *
     * @param projectId - A project identifier
     * @param attributeUris - Input list of attribute URIs
     * @returns Resolves with result list of attribute URIs
     */
    LdmModule.prototype.getCommonAttributes = function (projectId, attributeUris) {
        return this.xhr
            .post("/gdc/md/" + projectId + "/ldm/attributeupperbound", {
            body: {
                attributeUpperBounds: {
                    attributes: attributeUris,
                },
            },
        })
            .then(function (response) { return response.getData(); })
            .then(function (data) {
            if (data.attributeUpperBoundsResponse) {
                return data.attributeUpperBoundsResponse.upperbounds;
            }
        });
    };
    return LdmModule;
}());
exports.LdmModule = LdmModule;
//# sourceMappingURL=ldm.js.map